import { MutableRefObject, RefObject, createContext, createRef, useContext } from 'react';
import { noop } from 'utils/noop';

export type WYSIWYGContextState = {
  renderTiny: boolean;
  setRenderTiny: (condition: boolean) => void;
  /** html */
  htmlEditorRef: MutableRefObject<Record<string, any> | null>;
  loadHtmlFileInputRef: RefObject<HTMLInputElement>;
  isFullHtmlDoc: boolean;
  canLoadHTML: boolean;
  /** images */
  selectedImage?: HTMLImageElement;
  selectedImageAnchor?: HTMLAnchorElement;
  setSelectedImage: (element?: HTMLImageElement) => void;
  setSelectedImageAnchor: (element?: HTMLAnchorElement) => void;
  /** values */
  initValue: string;
  setInitValue: (value: string) => void;
  lastSavedValue: string;
  onChange: (content: string) => void;
  contentValue: string;
};

export const defaultState: WYSIWYGContextState = {
  renderTiny: true,
  setRenderTiny: noop,
  /** html */
  htmlEditorRef: createRef<MutableRefObject<Record<string, any>>>(),
  loadHtmlFileInputRef: createRef<HTMLInputElement>(),
  isFullHtmlDoc: false,
  canLoadHTML: false,
  /** images */
  selectedImage: undefined,
  selectedImageAnchor: undefined,
  setSelectedImage: noop,
  setSelectedImageAnchor: noop,
  /** values */
  initValue: '',
  setInitValue: noop,
  lastSavedValue: '',
  onChange: noop,
  contentValue: '',
};

export const WYSIWYGContext = createContext<WYSIWYGContextState>(defaultState);
export const useWYSIWYGContext = () => useContext(WYSIWYGContext);
